import { useState, useEffect } from "react";
import { useT } from "@/i18n/useT";

export default function NextUpdateCountdown({ nextUpdateAt }: { nextUpdateAt: string }) {
  const { t } = useT();
  const [text, setText] = useState("");
  useEffect(() => {
    const update = () => {
      const diff = new Date(nextUpdateAt).getTime() - Date.now();
      if (diff <= 0) {
        setText(t("updateAvailable"));
        return;
      }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      setText(h > 0 ? `${h}h ${m}m` : `${m}m`);
    };
    update();
    const id = setInterval(update, 30000);
    return () => clearInterval(id);
  }, [nextUpdateAt, t]);
  return <span>{text}</span>;
}
